const COMMON_URL = `${process.env.REACT_APP_FH_ORIGIN_URL}/common-config`

const CommonConfigApiUrls = {
  GET: `${COMMON_URL}/get`,
  POST: `${COMMON_URL}/create`,
  PUT: `${COMMON_URL}/update`,
  DELETE: `${COMMON_URL}/delete`,
  EXPORT: `${COMMON_URL}/download`
};

export default CommonConfigApiUrls
